import type { ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for popover component.
 *
 * @returns {ThemeStyle}
 */
export const getMuiPopoverStyle = (): ThemeStyle => {
  return {
    root: {
      '&>div[aria-hidden="true"]': {
        cursor: 'default',
      },
    },
  };
};
